<template>
  <q-table
    class="q-pb-sm text-weight-bold text-primary"
    flat
    bordered
    virtual-scroll
    style="height: 100%; border-color: #1976d2"
    table-header-class="text-grey"
    title-class="text-body1 text-bold"
    :rows-per-page-options="[0]"
    :columns="columns"
    :data="data.data"
    hide-pagination
    row-key="campaign_id"
    hide-no-data
  >
  </q-table>
</template>

<script>
export default {
  name: 'ListCampaignsAffiliate',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    columns() {
      return [
        {
          name: 'campaign_name',
          label: this.$t('campaigns'),
          field: 'campaign_name',
          align: 'left',
          sortable: true
        },
        {
          name: 'total_clicks',
          label: this.$t('clicks_amount'),
          field: 'total_clicks',
          align: 'center',
          sortable: true
        },
        {
          name: 'total_conversions',
          label: this.$t('conversion_amount'),
          field: 'total_conversions',
          align: 'center',
          sortable: true
        },
        {
          name: 'total_amount_cost',
          label: this.$t('commission'),
          field: (row) => parseFloat(row.total_amount_cost),
          align: 'right',
          sortable: true,
          format: (val) => 'R$ ' + parseFloat(val).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
      ];
    }
  },

  data() {
    return {
    };
  },

  methods: {}
};
</script>
